import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

const MagazineCard = ({ magazine }) => {

    const navigate = useNavigate();

    const handleClick = useCallback(() => {
        navigate(`/magazine/${magazine.id}`);
    }, [navigate, magazine.id]);

    return (
        <Card title={magazine.name}>
            <p>
                {magazine.description}
            </p>
            <Button variant="primary" onClick={handleClick}>Ver publicaciones</Button>
        </Card>
    );
}

export default MagazineCard;